import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import LeadSection from "./components/LeadSection";
import MissionSection from "./components/MissionSection";
import VisionSection from "./components/VisionSection";
import ValuesSection from "./components/ValuesSection";
import AboutSection from "./components/AboutSection";
import MessageSection from "./components/MessageSection";
import TeamSection from "./components/TeamSection";
import FinalCTASection from "./components/FinalCTASection";

export default function Company() {
  return (
    <PageLayout>
      <HeroSection />
      <LeadSection />
      <MissionSection />
      <VisionSection />
      <ValuesSection />
      <AboutSection />
      <MessageSection />
      <TeamSection />
      <FinalCTASection />
    </PageLayout>
  );
}
